export default __webpack_public_path__ + "static/media/bice-vida-empty-result.e5e035fb.png";